import {
  PERSONAL_DETAILS,
  SUPERANNUATION,
  TFN_DECLARATION,
} from '@/core/field-names';
import { shouldEnableLegalName } from '@/core/feature-flags';

function getFieldValueString(field) {
  if (!field) {
    return '';
  }

  const raw =
    field?.valueObj && field.valueObj.unformatted
      ? field.valueObj.unformatted
      : field?.value;

  if (typeof raw === 'string') return raw;
  if (typeof raw === 'number' || typeof raw === 'boolean') return String(raw);

  return '';
}

function buildFieldIndex(documents) {
  const fieldIndex = {};
  if (!Array.isArray(documents)) {
    return fieldIndex;
  }
  documents.forEach((documentItem) => {
    if (!documentItem || !Array.isArray(documentItem.fields)) return;
    documentItem.fields.forEach((fieldItem) => {
      if (fieldItem && fieldItem.name) {
        fieldIndex[fieldItem.name] = {
          field: fieldItem,
          document: documentItem,
        };
      }
    });
  });
  return fieldIndex;
}

function setStringFieldIfChanged(documentObj, field, newValue) {
  if (!field) {
    return false;
  }
  const current = getFieldValueString(field);
  if (current !== newValue) {
    field.value = newValue;
    documentObj.toSave = true;
    return true;
  }
  return false;
}

function updateTargets(fieldIndex, targetKeys, newValue) {
  targetKeys.forEach((key) => {
    const target = fieldIndex[key];
    if (target?.document && target?.field) {
      setStringFieldIfChanged(target.document, target.field, newValue);
    }
  });
}

function fillFromPersonalDetails(fieldIndex) {
  const firstName = getFieldValueString(
    fieldIndex[PERSONAL_DETAILS.FIRST_NAME]?.field
  ).trim();
  const lastName = getFieldValueString(
    fieldIndex[PERSONAL_DETAILS.LAST_NAME]?.field
  ).trim();

  if (!firstName && !lastName) {
    return;
  }

  const fullName = [firstName, lastName].filter((p) => !!p).join(' ');

  updateTargets(
    fieldIndex,
    [TFN_DECLARATION.NAME, SUPERANNUATION.NAME],
    fullName
  );
}

function fillTfnTitleFromPersonalDetails(fieldIndex) {
  const title = getFieldValueString(
    fieldIndex[PERSONAL_DETAILS.TITLE]?.field
  ).trim();
  if (!title) {
    return;
  }

  updateTargets(fieldIndex, [TFN_DECLARATION.TITLE], title);
}

function runHookAus(fieldIndex) {
  const isLegalNameEnabled = shouldEnableLegalName();

  if (isLegalNameEnabled) {
    fillFromPersonalDetails(fieldIndex);
    fillTfnTitleFromPersonalDetails(fieldIndex);
  }
}

export function afterSaveHooks({ documents, countryCode }) {
  if (!Array.isArray(documents) || documents.length === 0) {
    return;
  }

  const fieldIndex = buildFieldIndex(documents);

  switch (countryCode) {
    case 'AU': {
      runHookAus(fieldIndex);
      break;
    }
  }
}
